export default __webpack_public_path__ + "static/media/005.7a6561f5.jpg";